module.exports = new __parcel__URL__("bitcoin-1.d48db2ac.svg").toString();